import request from '@/utils/request'

/**
 * 微信支付收银
 * @param {Object} data 请求参数
 * @returns {Promise} 返回支付结果
 */
export function goodCashierToPay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment/goodCashierToPay',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 检查微信支付状态
 * @param {Object} data 请求参数
 * @returns {Promise} 返回支付状态
 */
export function checkGoodCashierToPay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment/checkGoodCashierToPay',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 现金支付收银
 * @param {Object} data 请求参数
 * @returns {Promise} 返回支付结果
 */
export function goodFaceToFaceCashierToPay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/payment/goodFaceToFaceCashierToPay',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * PC统一下单
 * @param {Object} data 请求参数
 * @returns {Promise} 返回订单结果
 */
export function pcUnifiedOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cart.pcUnifiedOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * PC扫码枪预下单
 * @param {Object} data 请求参数
 * @returns {Promise} 返回预下单结果
 */
export function pcQrCodeUnifiedOrderPre(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cart.pcQrCodeUnifiedOrderPre',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * PC扫码枪下单结果查询
 * @param {Object} data 请求参数
 * @returns {Promise} 返回查询结果
 */
export function pcQrCodeUnifiedOrderCheck(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cart.pcQrCodeUnifiedOrderCheck',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}